import { apiUrl } from './../constantsSMB/apiUrl'
import api from '../serviceSMB/apiService'
import { Utils } from '../utilSMB/utils';
import { errorAction } from './errorAction'
import { logKafka, logOtherInfo, detailsInfo, catchJSException } from './../serviceSMB/logService';
import { getVZDLInit } from '../serviceSMB/vzdl'

let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;

export const getCategoriesFromAPI = (dispatch, visitId) => {
    try {
        logOtherInfo(detailsInfo('AccessoriesHome', visitId, 'getCategoriesFromAPI', "Inside getCategoriesFromAPI"));
        var response;
        var categoriesData=window.catrespSMB
        const categoriesUrl = apiUrl().categoriesUrl;
        //  dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true, isLoaderText: "Just a moment, we're looking it up now." } });
        if (categoriesData !== undefined && categoriesData !== "" && categoriesData !== null  )
        {
            var response=categoriesData
            response = response.map(object => { return { ...object, actualImagePath: Utils.getDomainUrl().concat(object.imagePath), modifiedName: Utils.removeSpecialChars(object.name) } }
            )
            dispatch({ type: 'CATEGORIESFROMAPI', value: response });
               window.catrespSMB=""
        }
        else{
        api(categoriesUrl, 'GET', '').then(response => {
            if (Utils.isNotNull(response)) {
                response = response.map(object => { return { ...object, actualImagePath: Utils.getDomainUrl().concat(object.imagePath), modifiedName: Utils.removeSpecialChars(object.name) } }
                )
                dispatch({ type: 'CATEGORIESFROMAPI', value: response });
                // dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            }
            else {
                // dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                errorAction("LBO", "Category", "Category", "applogs", visitId, dispatch, true, "CategoryFailed")
            }
        }).catch(error => {
            let errorMsg = `MethodName:getCategoriesFromAPI,errorMessage:${error.message}`;
            logKafka("ERROR", "AccessoriesHome", errorMsg, getErrorLogUrl, "applogs", visitId);
            getVZDLInit(visitId,"","","","","","",error.message);
            // dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        })
        return response;
    }
    } catch (ex) {
        catchJSException('AccessoriesHome', visitId, 'getCategoriesFromAPI', ex);
    }
}

export const getStandardErrorsFromAPI = (dispatch, visitId) => {
    try {
        logOtherInfo(detailsInfo('AccessoriesHome', visitId, 'getStandardErrorsFromAPI', "Inside getStandardErrorsFromAPI"));
        var response;
        var stdErrData=window.strerrrespSMB
        const standardErrorsUrl = apiUrl().standardErrors;
        // dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true, isLoaderText: "Just a moment, we're looking it up now." } });
        if (stdErrData !== undefined && stdErrData !== "" && stdErrData !== null  )
        {
            dispatch({ type: 'STANDARDERRORSFROMAPI', value: stdErrData });  
            window.strerrrespSMB=""
        }
        else{
        api(standardErrorsUrl, 'GET', '').then(response => {
            if (Utils.isNotNull(response)) {               
                dispatch({ type: 'STANDARDERRORSFROMAPI', value: response });                
                // dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            }
            else {
                // dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                errorAction("LBO", "Category", "Category", "applogs", visitId, dispatch, true, "StandardErrorsFailed")
            }
        }).catch(error => {
            let errorMsg = `MethodName:getStandardErrorsFromAPI,errorMessage:${error.message}`;
            logKafka("ERROR", "AccessoriesHome", errorMsg, getErrorLogUrl, "applogs", visitId);
            getVZDLInit(visitId,"","","","","","",error.message);
            // dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        })
        return response;
    }
    } catch (ex) {
        catchJSException('AccessoriesHome', visitId, 'getStandardErrorsFromAPI', ex);
    }
}

export const getbannerFromAPI = (dispatch, visitId) => {
    try {
        logOtherInfo(detailsInfo('AccessoriesHome', visitId, 'getbannerFromAPI', "Inside getbannerFromAPI"));
        var response;
        var bannerData=window.bannerrespSMB
        const bannerUrl = apiUrl().bannerUrl;
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true, isLoaderText: "Just a moment, we're looking it up now." } });
        if (bannerData !== undefined && bannerData !== "" && bannerData !== null  )
            {
                var response=bannerData
                dispatch({ type: 'BANNERFROMAPI', value: response });
                // dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } })
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false, isLoaderText: "RESET_LOADER"}}); 
                window.bannerrespSMB=""
            }
        else{    
        api(bannerUrl, 'GET', '').then(response => {
            if (Utils.isNotNull(response)) {
                
                dispatch({ type: 'BANNERFROMAPI', value: response });
                // dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } })
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false, isLoaderText: "RESET_LOADER"}}); 
            }
        }).catch(error => {
            // dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } })
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false, isLoaderText: "RESET_LOADER"}}); 
            let errorMsg = `MethodName:getbannerFromAPI,errorMessage:${error.message}`;
            logKafka("ERROR", "AccessoriesHome", errorMsg, getErrorLogUrl, "applogs", visitId);
            getVZDLInit(visitId,"","","","","","",error.message);
        })
        return response;
     }
    } catch (ex) {
        catchJSException('AccessoriesHome', visitId, 'getbannerFromAPI', ex);
    }

}
export const getShoppingCartContent = (dispatch, visitId) => {
    try {
        logOtherInfo(detailsInfo('AccessoriesHome', visitId, 'getShoppingCartContent', "Inside getShoppingCartContent"));
        var response;
        const shoppingCartContentUrl = apiUrl().shoppingCartContentUrl;
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true, isLoaderText: "Just a moment, we're looking it up now." } });
        api(shoppingCartContentUrl, 'GET', '').then(response => {
            if (Utils.isNotNull(response)) {
                dispatch({ type: 'SHOPPINGCARTCONTENTFROMAPI', value: response });
                 dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            }
            else {
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            }
        }).catch(error => {
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            let errorMsg = `MethodName:getShoppingCartContents,errorMessage:${error.message}`;
            logKafka("ERROR", "AccessoriesHome", errorMsg, getErrorLogUrl, "applogs", visitId);
            getVZDLInit(visitId,"","","","","","",error.message);
        })
        return response;
    } catch (ex) {
        catchJSException('AccessoriesHome', visitId, 'getShoppingCartContent', ex);
    }

}


export const getHeaderContent = (dispatch, visitId) => {
    try {
        logOtherInfo(detailsInfo('AccessoriesHome', visitId, 'getHeaderContent', "Inside getHeaderContent"));
        var response;
        var headerData=window.tbarrespSMB
        const headerContentUrl = apiUrl().headerContentUrl;
        if (headerData !== undefined && headerData !== "" && headerData !== null  )
        {
            dispatch({ type: 'HEADERCONTENTFROMAPI', value: headerData });
        }
        else{
        api(headerContentUrl, 'GET', '').then(response => {
            if (Utils.isNotNull(response)) {
                dispatch({ type: 'HEADERCONTENTFROMAPI', value: response });
            }
        }).catch(error => {
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            let errorMsg = `MethodName:getHeaderContent,errorMessage:${error.message}`;
            logKafka("ERROR", "AccessoriesHome", errorMsg, getErrorLogUrl, "applogs", visitId);
            getVZDLInit(visitId,"","","","","","",error.message);
        })
        return response;
    }
    } catch (ex) {
        catchJSException('AccessoriesHome', visitId, 'getHeaderContent', ex);
    }

}

export const updateFlowType =(flowType,dispatch) => {
    if (flowType ) {
        const updateFlowTypeUrl = apiUrl().updateFlowType;
        let request = JSON.stringify({ flowType });
        api(updateFlowTypeUrl, 'POST', request).then(response => {
         dispatch({ type: 'UPDATEFLOWTYPE', value: flowType })   
        })
       .catch(error => {
        
       });
    }
}
export const updateLBO =(visitId,dispatch) => {
    
        const updateLBO = apiUrl().updateLOB;
        api(updateLBO, 'GET').then(response => {
         dispatch({ type: 'UPDATELBO', value: response })   
        })
       .catch(error => {
        let errorMsg = `MethodName:updateLBO,errorMessage:${error.message}`;
        logKafka("ERROR", "AccessoriesHome", errorMsg, getErrorLogUrl, "applogs", visitId);;
       });
    
}
export const updateClientIp =(dispatch,clientIp) => {
    dispatch({ type: 'UPDATE_CLIENTIP', value: clientIp });    
}
export const updateAcceptHeader =(dispatch,acceptHeader) => {
    dispatch({ type: 'UPDATE_ACCEPT_HEADER', value: acceptHeader });    
}
export const getfeaturedAccessoriesFromAPI = (dispatch, visitId, request) => {
    try {
        logOtherInfo(detailsInfo('AccessoriesHome', visitId, 'getfeaturedAccessoriesFromAPI', "Inside getfeaturedAccessoriesFromAPI"));
        var response;
        var selectedResponse;
        var ftAccData=window.ftrespSMB
        const featuredAccessoriesUrl = apiUrl().featuredAccessoriesUrl;
        // dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true, isLoaderText: "Just a moment, we're looking it up now." } });
        // if (ftAccData !== undefined && ftAccData !== "" && ftAccData !== null  )
        // {
        //    var response=ftAccData
        //    selectedResponse = response.map((object, index) => {
        //     return { ...object, selectedProd: object.items[0], groupId: "G" + index, modifiedName: Utils.removeSpecialChars(object.name) }
        // })
        //     dispatch({ type: 'FEATUREDACCESSORIESFROMAPI', value: selectedResponse });
        //     window.ftrespSMB=""
           
        // }
        // else{
        api(featuredAccessoriesUrl, 'POST', request).then(response => {
            if (Utils.isNotNull(response)) {
                selectedResponse = response.products.map((object, index) => {
                    return { ...object, selectedProd: object.items[0], groupId: "G" + index, modifiedName: Utils.removeSpecialChars(object.name) }
                })

                dispatch({ type: 'FEATUREDACCESSORIESFROMAPI', value: selectedResponse });
                // dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            }
            // dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        }).catch(error => {
            // dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            let errorMsg = `MethodName:getfeaturedAccessoriesFromAPI,errorMessage:${error.message}`;
            logKafka("ERROR", "AccessoriesHome", errorMsg, getErrorLogUrl, "applogs", visitId);
            getVZDLInit(visitId,"","","","","","",error.message);

        })
        return response;
    //  }
    } catch (ex) {
        catchJSException('AccessoriesHome', visitId, 'getfeaturedAccessoriesFromAPI', ex);
    }
}

export const setCookie = (cookies, data, props) => {
    {
        let domain = "localhost";
        if (document.location.href.indexOf("localhost") > -1) {
            //cookies.set('visit_id', data.visit_id, { path: '/', 'domain': domain });
            cookies.set('visit_id_vtp', data.visit_id, { path: '/', 'domain': domain });
            cookies.set('visitor_id', data.visitor_id, { path: '/', 'domain': domain });
        }
        props.dispatch({ type: "UPDATE_VISITID", value: { visitId: data.visit_id, visitorId: data.visitor_id } });
    }
}

export const storeCategoryId = (dispatch, request) => {
    dispatch({ type: 'STORECATEGORYID', value: request });
}
export const featuredAccessoriesvalue = (request, dispatch) => {
    dispatch({ type: 'FEATUREDACCESSORIESFROMAPI', value: request });
}

export const updateValidUser = (request, dispatch) => {
    dispatch({ type: 'VALIDUSER', value: request });
}

export const updateProfileCall = (request, dispatch) => {
    dispatch({ type: 'PROFILECALL', value: request });
}

export const updateGuestFlow = (request, dispatch) => {
    dispatch({ type: 'ISGUESTFLOW', value: request });
}

export const updateSigninApplied = (request, dispatch) => {
    dispatch({ type: 'ISSIGNINAPPLIED', value: request });
}

